
    $(document).scroll(function () {
      //stick nav to top of page
      var y = $(this).scrollTop();
      var navWrap = $('#shopify-section-header').offset().top;
      if (y > navWrap) {
          $('.sticky-search').addClass('sticky');
      } else {
          $('.sticky-search').removeClass('sticky');
      }
    });

(function($) {
      function formSubmitAjax($form) {
        return new Promise(function(resolve, reject) {
          $.ajax({
            url : $form.attr('action'),
            type: $form.attr('method'),
            data : $form.serialize(),
            dataType: 'json'
          }).done(function(response) {
            resolve(response);
          });      
        });
      }
      
      function addItemToCart(p_options) {
        var data = {
          quantity: p_options.quantity,
          id: p_options.variant_id,
        };

        if (p_options.properties !== undefined) {
          data['properties'] = p_options.properties
        }
        //console.log(data);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(data) { 
            if (typeof p_options.onSuccess === 'function') {
              p_options.onSuccess(data);
            }
          },
          error: function(error) { 
            if (typeof p_options.onError === 'function') {
              p_options.onError(error);
            }
          },
        });
      }
      
      function removeItemFromCart(p_options) {
        var data = {
          quantity: p_options.quantity,
          id: p_options.key
        };
        
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function(data) { 
            if (typeof p_options.onSuccess === 'function') {
              p_options.onSuccess(data);
            }
          },
          error: function(error) { 
            if (typeof p_options.onError === 'function') {
              p_options.onError(error);
            }
          },
        });
      }

      $(function() {
        console.log('READY');
        //console.log($('.shogun-root form[action="/cart/add"]'));
        $(document).on('submit', '.shogun-root form[action="/cart/add"]', function(e) {
          var $form = $(this);
          var $btn = $form.find('.shg-btn');
          $btn.addClass('btn-loading');

          e.preventDefault();

          formSubmitAjax($form)
          .then(function() {
            ajaxCart.init();
            ajaxCart.load();
            $btn.removeClass('btn-loading');
          });
        });
        
        // Shogun Bundle Pages
        var shogunCustomPages = ['/pages/bundle-dev'];

        var isBundlePage = shogunCustomPages.indexOf(location.pathname) !== -1;
        if (isBundlePage) {
          $('form').each(function() {
            var $form = $(this);
            var $btn = $form.find('.shg-btn');
            $btn.clone().text('Add to Bundle').addClass('cloned').appendTo($form);
            $form.find('.shg-btn.cloned').removeAttr('id').attr('data-id', $btn.attr('id'));
            $form.find('.shg-btn:first-of-type').hide();
          });
          
          // Check if already in cart
          $.getJSON('/cart.js', function(cart) {
            var bundleItems = _.filter(cart.items, function(item) {
              return item.properties._bundle;
            });
            
            _.each(bundleItems, function(lineItem) {
              var shogunItem = _.filter(__shgProductInits, function(item) {
                return item.productHandle == lineItem.handle;
              })[0];
              
              if (!_.isUndefined(shogunItem)) {
                $('#' + shogunItem.uuid).find('.shg-btn.cloned').attr('data-key', lineItem.key).addClass('added-to-cart').text('Added to Bundle!');
              }
            });
          });
          
          // Add/remove from cart
          $(document).on('click', 'form .shg-btn', function(e) {
            e.preventDefault();
            var $btn = $(this);
            var id = $btn.attr('data-id');
            var uuid = $btn.closest('.shg-product').attr('id');            
            var key = $btn.attr('data-key');
            var removingItem = !_.isUndefined(key);
            
            // Removing item from Cart
            if (removingItem) {
              removeItemFromCart({
                key: key,
                quantity: 0,
                onSuccess: function(response) {
                  $btn.removeClass('added-to-cart').text('Add to Bundle').blur();
                  $btn.removeAttr('data-key');
                },
                onError: function(error) {
                  console.log(error);
                }
              });
            }
            else {
              // Adding item to cart
              var variant = _.filter(__shgProductInits, function(item) {
                return item.uuid == uuid;
              })[0];

              $btn.addClass('adding-to-cart').text('Adding to Bundle');

              if (!_.isUndefined(variant)) {
                addItemToCart({
                  variant_id: variant.productVariantId,
                  quantity: 1,
                  properties: {
                    '_bundle': 'true'
                  },
                  onSuccess: function(response) {
                    $btn.removeClass('adding-to-cart').addClass('added-to-cart').text('Added to Bundle!').blur();
                    $btn.attr('data-key', response.key);
                  },
                  onError: function(error) {
                    console.log(error);
                  }
                });
              }
            }  
          });
          
          // On Cart button click, show cart drawer
          $(document).on('click', '.shg-btn[href*="cartdrawer=1"]', function(e) {
            e.preventDefault();
            ajaxCart.init();
            ajaxCart.load();
          });
        }        
      });
})(jQuery);

$("#DrawerOverlay").click(function(){  
   $(".drawer__close.js-drawer-close").trigger("click");
});

$(document).on('click','.checkoutcartbtn',function(){
  window.location.href ='/checkout';
});

$('.radio-select input[type="radio"]').click(function(){
    var value_checkbox = $(this).val();
    $('[name="id"]').val(value_checkbox);
    console.log(value_checkbox);
});

$(document).on("click","a.conshop.res",function() {
   $('.drawer__close.js-drawer-close').click();
});